Ext.define('SA.model.LocationHasCensusReleaseYearPredicate', {
    test({censusReleaseYear, location}) {
        return location.hasCensusReleaseYear(censusReleaseYear);
    }
});